// extracted by mini-css-extract-plugin
module.exports = {"content":"CompleteCard__content__vYIXC","editButton":"CompleteCard__editButton__vVuMT"};